export default {
  title: 'Controls',
  emptyState: {
    title: 'No controls added yet',
    description: 'Add controls to change what the map shows, from filters to analysis inputs',
    docsLink: 'Learn more in our Documentation'
  },
  modifiedCount: '{count, plural, one {# modified control} other {# modified controls}}',
  row: {
    descriptionDataset: '{type}, source column from dataset {letter}',
    descriptionPlaceholder: '{type}, SQL placeholder',
    descriptionUnresolved: '{type}, source dataset is not on the map'
  },
  pill: {
    notConfigured: 'Not configured',
    noData: 'No data',
    loadingValues: 'Loading values…',
    notConfiguredTitle: 'Not configured yet',
    notConfiguredDescription: 'Choose a source and a column in its settings to finish setting it up.',
    noDataEditorDescription: '{column} in {source} has no rows yet. The control applies no filter until data arrives.',
    noDataViewerDescription: "There's no data for this control yet. It will update as soon as data arrives."
  },
  reorder: {
    instructions:
      'Press Space or Enter to start reordering. Use the up and down arrow keys to move the control, Space or Enter to drop it, and Escape to cancel.'
  }
}
